import { pickStringUnion, readString } from '@/lib/prop-utils';

export const IMAGE_SIZE_VALUES = ['extra-small', 'compact', 'regular', 'large', 'full'] as const;

export type ExplicitImageSize = (typeof IMAGE_SIZE_VALUES)[number];
export type RequestedImageSize = ExplicitImageSize | 'auto';

interface ImageSizePreset {
  label: string;
  className: string;
  maxWidth?: number;
}

const IMAGE_SIZE_PRESETS: Record<ExplicitImageSize, ImageSizePreset> = {
  'extra-small': { label: 'XS', className: 'max-w-32', maxWidth: 128 },
  compact: { label: 'S', className: 'max-w-56', maxWidth: 224 },
  regular: { label: 'M', className: 'max-w-sm', maxWidth: 384 },
  large: { label: 'L', className: 'max-w-3xl', maxWidth: 768 },
  full: { label: 'Full', className: 'max-w-none' },
};

export const IMAGE_SIZE_OPTIONS: Array<{ value: ExplicitImageSize; label: string }> =
  IMAGE_SIZE_VALUES.map((value) => ({ value, label: IMAGE_SIZE_PRESETS[value].label }));

export function readImageSize(value: unknown): RequestedImageSize {
  return pickStringUnion<RequestedImageSize>(readString(value), IMAGE_SIZE_VALUES, 'auto');
}

export function readExplicitImageSize(value: unknown): ExplicitImageSize | undefined {
  const size = readImageSize(value);
  return size === 'auto' ? undefined : size;
}

export function getImageSizeClassName(size: ExplicitImageSize): string {
  return IMAGE_SIZE_PRESETS[size].className;
}

export function getImageSizeMaxWidth(size: ExplicitImageSize): number | undefined {
  return IMAGE_SIZE_PRESETS[size].maxWidth;
}
